import { Routes } from '@angular/router';
import { authGuard } from './core/session/auth.guard';
import { CampanhaDetalheComponent } from './features/campanha-detalhe/campanha-detalhe.component';
import { CampanhaFormComponent } from './features/campanha-form/campanha-form.component';
import { campanhaEdicaoGuard } from './features/campanha-form/campanha-edicao.guard';
import { CampanhasListComponent } from './features/campanhas-list/campanhas-list.component';
import { NotFoundComponent } from './features/not-found/not-found.component';
import { FuncionalidadesComponent } from './features/funcionalidades/funcionalidades.component';
import { QuestionariosListComponent } from './features/questionarios-list/questionarios-list.component';
import { QuestionarioFormComponent } from './features/questionario-form/questionario-form.component';
import { PerfilCadastroComponent } from './features/perfil-cadastro/perfil-cadastro.component';
import { PerfilListComponent } from './features/perfil-list/perfil-list.component';
import { PerfilDetalheComponent } from './features/perfil-detalhe/perfil-detalhe.component';
import { IntegracaoSelecaoComponent } from './features/integracao-selecao/integracao-selecao.component';
import { IntegracaoGestaoComponent } from './features/integracao-gestao/integracao-gestao.component';

export const routes: Routes = [
  { path: '', component: FuncionalidadesComponent, canActivate: [authGuard] },
  { path: 'campanhas', component: CampanhasListComponent, canActivate: [authGuard] },
  { path: 'campanhas/nova', component: CampanhaFormComponent, canActivate: [authGuard] },
  {
    path: 'campanhas/:id/editar',
    component: CampanhaFormComponent,
    canActivate: [authGuard, campanhaEdicaoGuard],
  },
  { path: 'campanhas/:id', component: CampanhaDetalheComponent, canActivate: [authGuard] },
  { path: 'questionarios', component: QuestionariosListComponent, canActivate: [authGuard] },
  { path: 'questionarios/novo', component: QuestionarioFormComponent, canActivate: [authGuard] },
  { path: 'questionarios/:id/editar', component: QuestionarioFormComponent, canActivate: [authGuard] },
  { path: 'perfis', component: PerfilListComponent, canActivate: [authGuard] },
  { path: 'perfis/novo', component: PerfilCadastroComponent, canActivate: [authGuard] },
  { path: 'perfil/configuracoes', component: PerfilDetalheComponent, canActivate: [authGuard] },
  { path: 'perfil/:id/editar', component: PerfilCadastroComponent, canActivate: [authGuard] },
  { path: 'perfil/:id', component: PerfilDetalheComponent, canActivate: [authGuard] },
  { path: 'integracao', component: IntegracaoSelecaoComponent, canActivate: [authGuard] },
  { path: 'integracao/:id', component: IntegracaoGestaoComponent, canActivate: [authGuard] },
  { path: 'not-found', component: NotFoundComponent },
  { path: '**', redirectTo: 'not-found' },
];
